import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-gray-50 py-16 md:py-20 px-4" data-id="element-193">
      <div className="max-w-3xl mx-auto text-center" data-id="element-194">
        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-lg border border-green-200" data-id="element-195">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-196">
            <ShieldCheckIcon className="w-10 h-10 text-green-600" data-id="element-197" />
          </div>

          <h2 className="font-heading font-bold text-3xl md:text-4xl text-gray-900 mb-6" data-id="element-198">
            🔒 Garantía sin riesgo
          </h2>

          <p className="font-body text-lg md:text-xl text-gray-700 leading-relaxed mb-4" data-id="element-199">
            Probalo durante 7 días.
          </p>

          <p className="font-body text-lg md:text-xl text-gray-700 leading-relaxed mb-4" data-id="element-200">
            Si no te ayuda a entender el Tarot y conectar con vos mismo,
            <br data-id="element-201" />
            <span className="font-semibold text-green-600" data-id="element-202">
              te devolvemos el 100% del dinero.
            </span>
          </p>

          <p className="font-heading font-bold text-xl text-gray-900" data-id="element-203">
            Sin preguntas.
          </p>
        </div>
      </div>
    </section>;
}